import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ErrorInterface, ErrorService } from './error.service';

@Component({
  selector: 'app-errorbar',
  templateUrl: './errorbar.component.html',
  styleUrls: ['./errorbar.component.css']
})

export class ErrorbarComponent implements OnDestroy {

  private errorSubscription: Subscription;
  public showErrors: boolean = false;

  public alertPool: Array<ErrorInterface>;
  // private alertPoolSize: number = 5;
  // private alertPoolDelay: number = 10000;

  constructor(private err: ErrorService) {
    this.alertPool = [];
    this.errorSubscription = this.err.onError.subscribe(this.onError.bind(this));
  };

  public countErrors (): number {
    if (this.alertPool.length === 0) return 0;
    let count: number = 0;
    this.alertPool.forEach((i: ErrorInterface) => count += i.counter)
    return count
  };

  private onError(ev: ErrorInterface): void {
    if (['error', 'warn'].indexOf(ev.level) === -1) {
      return;
    }
    if (this.alertPool.length > 0 && this.alertPool[0].level === ev.level && this.alertPool[0].text === ev.text) this.alertPool[0].counter++
    else this.alertPool.unshift({
      level: ev.level,
      text: ev.text,
      counter: 1
    });
    // this.alertPool.splice(this.alertPoolSize);
    // setTimeout(this.discardAlert.bind(this), this.alertPoolDelay);
  };

  public errorsBlockHandler(): void {
    this.showErrors = !this.showErrors;
  };

  public setStyleToError(level: string): string {
    return level === 'warn' ? 'yellow' : level === 'error' ? 'red' : '';
  };

  // private discardAlert(): void {
  //     if (this.alertPool.length > 0) {
  //         this.alertPool.splice(this.alertPool.length - 1);
  //     }
  // }

  ngOnDestroy() {
    this.errorSubscription.unsubscribe();
  };

}



// WEBPACK FOOTER //
// ./src/app/errorbar/errorbar.component.ts